import { GetOneResponsibleInDto, GetOneResponsibleOutDto } from '../../../types/responsible.dto'

export const GET_ONE_RESPONSIBLE = 'GET_ONE_RESPONSIBLE'
export const GET_ONE_RESPONSIBLE_SUCCESS = 'GET_ONE_RESPONSIBLE_SUCCESS'
export const GET_ONE_RESPONSIBLE_ERROR = 'GET_ONE_RESPONSIBLE_ERROR'
export const RESET_GET_ONE_RESPONSIBLE = 'RESET_GET_ONE_RESPONSIBLE'

export interface GetOneResponsible {
  type: typeof GET_ONE_RESPONSIBLE
  payload: GetOneResponsibleOutDto
}

export interface GetOneResponsibleSuccess {
  type: typeof GET_ONE_RESPONSIBLE_SUCCESS
  payload: GetOneResponsibleInDto
}

export interface GetOneResponsibleError {
  type: typeof GET_ONE_RESPONSIBLE_ERROR
  payload: string | boolean
}

export interface ResetGetOneResponsible {
  type: typeof RESET_GET_ONE_RESPONSIBLE
  payload: null
}

export interface State {
  data: GetOneResponsibleInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetOneResponsible | GetOneResponsibleSuccess | GetOneResponsibleError | ResetGetOneResponsible
